import {
  ADMIN_NAV, ADMIN_DASHBOARD, ADMIN_EMPLOYEES, POLICY_LIBRARY, DOCUMENT_LIBRARY,
  ANNOUNCEMENTS, TALENT_MAP, RECEIPTS_BATCH, CORRECTION_INBOX, FAILED_EMAILS_INBOX,
  CONSULTING, ADVISOR, EMPLOYEE_NAV, EMPLOYEE_PORTAL, EXPEDIENTE_TABS,
  EMPLOYEE_VACATION_REQUEST, EMPLOYEE_RECEIPTS, MY_DATA,
} from "@/constants/testIds";

const sel = (testid) => (testid ? `[data-testid="${testid}"]` : undefined);

// Contenido de cada tour basado en las guías PDF de uso (Admin y Empleado), aplicado sobre
// los elementos reales de cada pantalla en vez de capturas. IMPORTANTE: cada vez que se
// agrega una pestaña/sección nueva al sidebar del Admin o a la navegación del Empleado, hay
// que agregar también su tarjeta aquí — ver checklist en CONTRIBUTING.md ("Nueva sección de
// navegación"). No cubre Facturación todavía (pendiente de agregar).

export const ADMIN_TOUR_GROUPS = [
  {
    route: "/admin",
    steps: [
      {
        title: "Antes de empezar",
        description:
          "CERH concentra expedientes, documentos, vacaciones, avisos y controles de cumplimiento. Si una acción genera, envía, aprueba, resuelve, asigna, carga o da de baja, valida primero al empleado, la fecha y el alcance — los documentos legales y estimados deben revisarse con el profesional correspondiente.",
      },
      {
        target: sel(ADMIN_DASHBOARD.semaphore),
        title: "Dashboard de Cumplimiento",
        description: "Panorama general, no es una lista de documentos: te dice de un vistazo si tu empresa está en orden o si algo requiere atención.",
        side: "bottom",
      },
      {
        target: sel(ADMIN_DASHBOARD.statTotalEmployees),
        title: "Tarjetas con acceso directo",
        description: "Cada tarjeta funciona como acceso directo: selecciónala para abrir la lista filtrada correspondiente (políticas pendientes, incidencias, vacaciones por aprobar...).",
        side: "bottom",
      },
      {
        target: sel(ADMIN_DASHBOARD.moduleTeaserCard),
        title: "Accesos rápidos",
        description: "Vacaciones, Aviso de Rescisión Asistido, Considera Antes de Decidir y Mapa de Talento Crítico, siempre a un clic desde aquí.",
        side: "top",
      },
    ],
  },
  {
    route: "/admin/empleados",
    steps: [
      {
        target: sel(ADMIN_EMPLOYEES.searchInput),
        title: "Empleados y expedientes",
        description: "Usa el buscador para localizar a una persona por nombre. Revisa las alertas visibles antes de abrir su expediente.",
        side: "bottom",
      },
      {
        target: sel(ADMIN_EMPLOYEES.newEmployeeButton),
        title: "Dar de alta a un empleado",
        description: "Captura nombre, correo, teléfono, puesto, tipo de contrato, fecha de contratación y centro de trabajo. El correo se usará para su cuenta — revísalo antes de confirmar.",
        side: "bottom",
      },
      {
        target: sel(ADMIN_EMPLOYEES.employeeRow),
        title: "Dentro de un expediente",
        description: "Selecciona la tarjeta de cualquier persona para abrir sus pestañas: Políticas, Incidencias, Vacaciones, Salario, Recibos, Avisos, Considera Antes de Decidir y Baja. El historial de salario y las incidencias quedan como registro inmutable.",
        side: "bottom",
      },
      {
        title: "Decisiones sensibles",
        description: "Los costos de una baja son estimados, nunca una cifra final. Una baja debe apoyarse en hechos e incidencias documentadas, y el aviso de rescisión requiere revisión legal antes de entregarse.",
      },
    ],
  },
  {
    route: "/admin/politicas",
    steps: [
      {
        target: sel(POLICY_LIBRARY.legalDisclaimer),
        title: "Biblioteca de Documentos",
        description: "CERH no sustituye la asesoría de un abogado laboral. Todo lo que generes aquí queda pendiente de validación profesional antes de tener carácter definitivo.",
        side: "bottom",
      },
      {
        target: sel(DOCUMENT_LIBRARY.acuseSection),
        title: "Documentos generales (acuse de lectura)",
        description: "Se generan una vez para toda la empresa y se distribuyen para que cada persona confirme su lectura.",
        side: "top",
      },
      {
        target: sel(DOCUMENT_LIBRARY.firmaSection),
        title: "Documentos por empleado (firma física)",
        description: "Contratos, convenios y anexos individuales. Usa \"Historial\" en cada tarjeta antes de generar uno nuevo, para evitar duplicados y revisar versiones anteriores.",
        side: "top",
      },
    ],
  },
  {
    route: "/admin/vacaciones",
    steps: [
      {
        title: "Control de Vacaciones",
        description: "Aquí ves y respondes las solicitudes de vacaciones de tus empleados (Art. 76/78 LFT): apruébalas, recházalas, o asígnalas tú mismo cuando decidas las fechas por ellos.",
      },
    ],
  },
  {
    route: "/admin/avisos",
    steps: [
      {
        target: sel(ANNOUNCEMENTS.messageInput),
        title: "Avisos",
        description: "Redacta un comunicado breve, claro y sin datos sensibles innecesarios.",
        side: "bottom",
      },
      {
        target: sel(ANNOUNCEMENTS.recipientAllRadio),
        title: "Destinatarios",
        description: "Elige entre todos los empleados o personas específicas, y revisa la selección antes de enviar.",
        side: "right",
      },
      {
        title: "Diferencia clave",
        description: "Un aviso es un comunicado informal. Para reglas que requieren evidencia de conocimiento, usa una política y su acuse, no un aviso.",
      },
    ],
  },
  {
    route: "/admin/talento",
    steps: [
      {
        target: sel(TALENT_MAP.exportCsvButton),
        title: "Mapa de Talento Crítico",
        description: "Filtra entre talento a retener, revisar antes de decidir y sin señales fuertes. La clasificación usa solo antigüedad e incidencias — no sustituye una evaluación de desempeño formal. Exporta CSV solo cuando sea necesario y protege el archivo.",
        side: "bottom",
      },
    ],
  },
  {
    route: "/admin/recibos",
    steps: [
      {
        target: sel(RECEIPTS_BATCH.periodInput),
        title: "Recibos en lote",
        description: "Define el periodo y la fecha de emisión antes de subir archivos.",
        side: "bottom",
      },
      {
        target: sel(RECEIPTS_BATCH.employeeRow),
        title: "Un archivo por persona",
        description: "Selecciona el archivo correcto para cada empleado y verifica el contador de archivos listos antes de subir. No mezcles recibos entre personas.",
        side: "bottom",
      },
    ],
  },
  {
    route: "/admin/correcciones",
    steps: [
      {
        target: sel(CORRECTION_INBOX.page),
        title: "Correcciones de datos",
        description: "Aquí llegan las solicitudes que los empleados envían desde \"Mis datos\". Compara el cambio con el expediente actual, solicita soporte si el dato lo requiere, actualiza el expediente correspondiente, y marca la solicitud como resuelta solo cuando ya la atendiste.",
        side: "bottom",
      },
    ],
  },
  {
    route: "/admin/envios-fallidos",
    steps: [
      {
        target: sel(FAILED_EMAILS_INBOX.page),
        title: "Envíos fallidos",
        description: "Correos que el proveedor rechazó. Corrige la causa o contacta manualmente al destinatario, y márcalo como resuelto únicamente después de atenderlo.",
        side: "bottom",
      },
    ],
  },
  {
    route: "/admin/perfil-empresa",
    steps: [
      {
        target: sel("dashboard-work-week-select"),
        title: "Perfil de Empresa",
        description: "Configura primero los días laborables reales de tu empresa.",
        side: "bottom",
      },
      {
        target: sel(ADMIN_DASHBOARD.razonSocialInput),
        title: "Datos legales de la empresa",
        description: "Razón social, RFC, domicilio completo y representante legal — verifícalos contra documentos oficiales. Se usan para autocompletar los documentos que generes en la Biblioteca de Documentos.",
        side: "bottom",
      },
      {
        target: sel(ADMIN_DASHBOARD.expectedCheckinTimeInput),
        title: "Horarios y alertas de asistencia",
        description: "El horario esperado de entrada/salida y su tolerancia alimentan las alertas del Dashboard cuando alguien no marca su jornada a tiempo.",
        side: "top",
      },
    ],
  },
  {
    route: "/admin/consultoria",
    steps: [
      {
        target: sel(CONSULTING.requestButton),
        title: "Consultoría",
        description: "Úsala cuando necesites orientación estratégica: describe la situación de forma objetiva, evitando datos sensibles innecesarios. Enviar la solicitud no tiene costo — el profesional te informa costo y tiempo antes de cobrar.",
        side: "bottom",
      },
    ],
  },
  {
    route: "/admin/jornada",
    steps: [
      {
        title: "Registro de Jornada",
        description: "Aquí ves quién marcó su entrada y salida hoy, capturas un marcaje manual si alguien no tiene celular ni acceso al kiosko, y consultas el Reporte Semanal de Asistencia con faltas y retardos por persona.",
      },
    ],
  },
  {
    route: "/admin/centros-de-trabajo",
    steps: [
      {
        title: "Centros de Trabajo",
        description: "Define aquí las ubicaciones de tu empresa arrastrando un marcador en el mapa, para que el sistema pueda comparar dónde marcan sus horarios tus empleados.",
      },
    ],
  },
  {
    route: "/admin",
    steps: [
      {
        target: sel(ADVISOR.admin.fabButton),
        title: "Consultor de RH",
        description: "Este botón te acompaña en cualquier sección del panel. Pregúntale sobre cumplimiento, riesgos o estrategia de RH, y usa el engrane para personalizar el contexto de tu empresa.",
        side: "left",
      },
      {
        title: "Validación obligatoria",
        description: "El Consultor ofrece orientación. Las recomendaciones, documentos, cálculos y cifras deben validarse con un abogado laboral, contador o profesional competente antes de actuar.",
      },
      {
        target: sel(ADMIN_NAV.logoutButton),
        title: "Rutina recomendada",
        description: "Cada ingreso: revisa Atención requerida, correcciones y vacaciones por aprobar. Semanal: políticas pendientes, incidencias y avisos sin leer. Mensual: saldos de vacaciones, recibos y envíos fallidos. Al terminar, cierra sesión aquí — sobre todo en equipos compartidos.",
        side: "top",
      },
    ],
  },
];

export const EMPLOYEE_TOUR_GROUPS = [
  {
    route: "/portal",
    steps: [
      {
        title: "Antes de empezar",
        description: "Nunca compartas tu contraseña. Revisa cuidadosamente una política antes de confirmar su lectura, y verifica las fechas antes de solicitar vacaciones.",
      },
      {
        target: sel(EMPLOYEE_PORTAL.policyReminderPinnedCard),
        title: "Pantalla de inicio",
        description: "Aquí ves recordatorios, avisos y tus políticas pendientes de confirmar.",
        side: "bottom",
      },
      {
        target: sel(EMPLOYEE_PORTAL.vacationBalance),
        title: "Tu saldo de vacaciones",
        description: "Tu saldo general de días disponibles, siempre visible en Inicio.",
        side: "top",
      },
      {
        target: sel(EMPLOYEE_PORTAL.acknowledgeButton),
        title: "Confirmar una política",
        description: "Selecciona \"He leído y confirmo\" solamente después de abrir y revisar el documento completo.",
        side: "top",
      },
      {
        target: sel(EMPLOYEE_NAV.bottomNav),
        title: "Navegación",
        description: "Usa esta barra para moverte entre Inicio, Expediente, Vacaciones, Recibos y Jornada (para marcar tu entrada/salida y ver tu historial de asistencia).",
        side: "top",
      },
    ],
  },
  {
    route: "/portal/expediente",
    steps: [
      {
        target: sel(EXPEDIENTE_TABS.tabDatos),
        title: "Mi expediente",
        description: "Consulta tus datos laborales y personales. Si algo está mal, usa \"Solicitar corrección\": describe el dato actual y la corrección solicitada, y espera la revisión de Recursos Humanos.",
        side: "bottom",
      },
      {
        target: sel(MY_DATA.requestCorrectionButton),
        title: "Solicitar una corrección",
        description: "Tus datos son de solo lectura para mantener el control de auditoría — cualquier cambio pasa por esta solicitud.",
        side: "top",
      },
      {
        target: sel(EXPEDIENTE_TABS.tabSalario),
        title: "Mi salario",
        description: "La compensación mensual que tu empresa decidió hacer visible para ti.",
        side: "bottom",
      },
      {
        target: sel(EXPEDIENTE_TABS.tabPoliticas),
        title: "Políticas",
        description: "Políticas confirmadas y pendientes de lectura.",
        side: "bottom",
      },
      {
        target: sel(EXPEDIENTE_TABS.tabDocumentos),
        title: "Documentos",
        description: "Documentos laborales disponibles y sus versiones firmadas. No confirmes un documento que no hayas podido abrir — repórtalo a Recursos Humanos.",
        side: "bottom",
      },
      {
        target: sel(EXPEDIENTE_TABS.tabIncidencias),
        title: "Incidencias",
        description: "Incidencias registradas en tu expediente.",
        side: "bottom",
      },
    ],
  },
  {
    route: "/portal/vacaciones",
    steps: [
      {
        title: "Mis vacaciones",
        description: "Conforme a los Art. 76 y 78 de la LFT. Revisa los días disponibles de cada año y si tienes días de años anteriores sin programar.",
      },
      {
        target: sel(EMPLOYEE_VACATION_REQUEST.requestButton),
        title: "Solicitar vacaciones",
        description: "Elige las fechas correctas, revisa la cantidad de días, y envía tu solicitud. Enviarla no significa que ya fue aprobada — consulta después su estado.",
        side: "top",
      },
    ],
  },
  {
    route: "/portal/recibos",
    steps: [
      {
        target: sel(EMPLOYEE_RECEIPTS.blockedBanner),
        title: "Mis recibos",
        description: "Si tienes políticas pendientes de confirmar, esta sección se bloquea temporalmente hasta que las confirmes.",
        side: "bottom",
      },
      {
        target: sel(EMPLOYEE_RECEIPTS.receiptRow),
        title: "Historial de nómina",
        description: "Abre o descarga el recibo del periodo que quieras consultar, y guárdalo en un lugar privado y seguro.",
        side: "bottom",
      },
    ],
  },
  {
    route: "/portal",
    steps: [
      {
        target: sel(ADVISOR.employee.fabButton),
        title: "Asesor Personal",
        description: "Te acompaña en cualquier sección del portal. Pregúntale sobre tus políticas, vacaciones o incidencias — solo ve tu propia información, nunca la de otros empleados.",
        side: "left",
      },
      {
        title: "Privacidad y alcance",
        description: "Sus respuestas son orientativas y no sustituyen asesoría legal; para disputas o dudas legales, contacta a Recursos Humanos.",
      },
      {
        target: sel(EMPLOYEE_NAV.logoutButton),
        title: "Cerrar sesión",
        description: "Cuando termines, cierra sesión aquí — sobre todo en equipos compartidos, para no dejar tu cuenta abierta.",
        side: "bottom",
      },
    ],
  },
];
